const navLinks = [
  { href: "#top", label: "首页" },
  { href: "#pick", label: "治愈精选" },
  { href: "#list", label: "番剧合集" },
  { href: "#pian", label: "片单合集" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

const catLinks = ["治愈系", "日常系", "温馨番剧", "萌系动画"];

export default function Footer() {
  return (
    <footer className="bg-primary-800">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-primary-600">
                <i className="ri-movie-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl text-background-50">小狗看番</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-primary-100">
              治愈系、日常系、温馨番剧与萌系动画的一站式片单合集。
              每部标注看点与集数，帮你在疲惫时快速找到那部暖心好番。
            </p>
            <div className="mt-5 flex gap-3">
              <a
                href="#top"
                aria-label="微博"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-700 text-primary-100 transition-colors hover:bg-primary-600"
              >
                <i className="ri-weibo-fill"></i>
              </a>
              <a
                href="#top"
                aria-label="微信"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-700 text-primary-100 transition-colors hover:bg-primary-600"
              >
                <i className="ri-wechat-fill"></i>
              </a>
              <a
                href="#top"
                aria-label="哔哩哔哩"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-700 text-primary-100 transition-colors hover:bg-primary-600"
              >
                <i className="ri-bilibili-fill"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50">站内导航</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-primary-100 transition-colors hover:text-background-50"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50">番剧栏目</h3>
            <ul className="mt-4 space-y-2.5">
              {catLinks.map((c) => (
                <li key={c}>
                  <a
                    href="#list"
                    className="text-sm text-primary-100 transition-colors hover:text-background-50"
                  >
                    {c}片单
                  </a>
                </li>
              ))}
            </ul>
            <p className="mt-5 text-sm text-primary-100">
              联系邮箱：
              <a
                href="mailto:hello@xiaogoukanfan.example"
                className="text-background-50 underline-offset-2 hover:underline"
              >
                hello@xiaogoukanfan.example
              </a>
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-primary-700/70 pt-6 sm:flex-row">
          <p className="text-xs text-primary-100">
            © {new Date().getFullYear()} 小狗看番 · 治愈系番剧推荐站。仅供片单参考，播放请前往正版平台。
          </p>
          <p className="text-xs text-primary-100">愿你今天，也被温柔以待。</p>
        </div>
      </div>
    </footer>
  );
}